import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
        padding: '16px',
        backgroundColor: theme.palette.common.white,
        borderRadius: '6px',
        boxSizing: 'border-box',
    },
    search_container: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '16px',
    },
    table_container: {
        border: '1px solid #e0e0e0',
        borderRadius: '0 0 6px 6px',
        height: 'calc(100vh - 245px)',
        overflow: 'auto',
        position: 'relative',
    },
    table_header: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 1fr',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: 600,
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    table_row: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 1fr',
        padding: '12px 16px',
        borderBottom: '1px solid #f0f0f0',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#f8f9fa',
        },
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    town_name: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#333',
    },
    service_cell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
    },
    service_label: {
        fontSize: '12px',
        color: '#666',
        textAlign: 'center',
    },
    toggle_switch: {
        position: 'relative',
        display: 'inline-block',
        width: '44px',
        height: '24px',
    },
    toggle_input: {
        opacity: 0,
        width: 0,
        height: 0,
    },
    toggle_slider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#ccc',
        transition: '0.3s',
        borderRadius: '24px',
        '&:before': {
            position: 'absolute',
            content: '""',
            height: '18px',
            width: '18px',
            left: '3px',
            bottom: '3px',
            backgroundColor: 'white',
            transition: '0.3s',
            borderRadius: '50%',
        },
    },
    toggle_checked: {
        '& $toggle_slider': {
            backgroundColor: theme.palette.secondary.main,
        },
        '& $toggle_slider:before': {
            transform: 'translateX(20px)',
        },
    },
    empty_state: {
        padding: '32px',
        textAlign: 'center',
        color: '#666',
        fontSize: '14px',
    },
    loading_state: {
        padding: '32px',
        textAlign: 'center',
        color: '#666',
        fontSize: '14px',
    },
}));

export { useStyles };
